import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './ErrorBoundary'
import { setupServiceWorker } from './pwaRegister'
import './index.css'

setupServiceWorker()

const RUNTIME_HEAL_KEY = 'colorphoto_runtime_heal_attempted'

async function clearClientCachesSafely() {
  try {
    if (typeof navigator !== 'undefined' && navigator.serviceWorker?.getRegistrations) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister().catch(() => {})))
    }
  } catch {
    // ignore
  }
  try {
    if (typeof caches !== 'undefined' && caches.keys) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)))
    }
  } catch {
    // ignore
  }
}

window.addEventListener('error', (event) => {
  const msg = String(event?.error?.message || event?.message || '')
  if (!/before initialization/i.test(msg)) return
  try {
    if (sessionStorage.getItem(RUNTIME_HEAL_KEY) === '1') return
    sessionStorage.setItem(RUNTIME_HEAL_KEY, '1')
  } catch {
    return
  }
  void clearClientCachesSafely().finally(() => {
    window.location.reload()
  })
})

const root = document.getElementById('root')
if (!root) {
  document.body.innerHTML = '<div style="padding:2rem;color:#eaeaea;font-family:system-ui;text-align:center;min-height:100vh;background:#1a1a2e;">לא נמצא אלמנט root. בדוק את index.html.</div>'
} else {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  )
}
